import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetBlogListSucceed, EGetBlogListActionType } from './types';
import { IBlogList } from '../../../types/blogList';

export const getBlogListSucceed: (data: IBlogList) => TGetBlogListSucceed = actionGenerator<
  EGetBlogListActionType.Succeed,
  IBlogList
>(EGetBlogListActionType.Succeed);
